import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatStepperModule } from '@angular/material/stepper';
import { MatRadioModule } from '@angular/material/radio';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { LocalizedNativeDateModule } from 'src/app/core/i18n/localized-date-adapter';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LeaveService } from '../../shared/services/leave.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Holiday } from '../../shared/models/calendar-holidays';
import { MessageService } from '../../shared/errorHandler/message.service';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

/**
 * Extracts the calendar year from a date-like value regardless of the date
 * adapter in use (native Date, Moment-like, or Luxon DateTime-like), without
 * requiring the 'moment' package (avoids a CommonJS optimization bailout).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getYearFromDateLike(d: any): number {
  if (d instanceof Date) {
    return d.getFullYear();
  }
  if (typeof d?.year === 'function') {
    // Moment-like API
    return d.year();
  }
  if (typeof d?.year === 'number') {
    // Luxon DateTime-like API
    return d.year;
  }
  return d?.getFullYear?.();
}

@Component({
  standalone: true,
  selector: 'app-add-dialog-holiday',
  templateUrl: './add-dialog-holiday.component.html',
  styleUrls: ['./add-dialog-holicady.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatDialogModule,
    FlexLayoutModule,
    MatStepperModule,
    MatRadioModule,
    MatOptionModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatRippleModule,
    LocalizedNativeDateModule,
    MatSlideToggleModule,
    TranslocoModule
  ]
})
export class AddHolidayDialogComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly transloco = inject(TranslocoService);
  menuFormHoliday: UntypedFormGroup;
  tiposDeFeriados = ['Nacional', 'Local','Actividad', 'Otro'];
  error = '';
  MinDate: Date;
  MaxDate: Date;
  HastaMinDate: Date;
  loading= false;
  holiday: Holiday;
  holidayYear: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { holiday: Holiday; year: string },
    private dialogRef: MatDialogRef<AddHolidayDialogComponent>,
    private _formBuilder: FormBuilder,
    private leaveService: LeaveService,
    private msjService: MessageService
  ) {
    this.menuFormHoliday = this._formBuilder.group({
      TipoFeriado: [""],
      description: [""],
      DateFeriado: [""],
      EffectiveDate: [""],
      state: [true],
    });

    this.holiday = this.data.holiday;
    this.holidayYear = this.data.year;
  }

  ngOnInit(): void {
    if(this.holiday.id != undefined)
    {
      this.menuFormHoliday.patchValue({
        TipoFeriado:this.holiday.holidayType,
        description: this.holiday.description,
        DateFeriado: this.holiday.holidayDate,
        EffectiveDate: this.holiday.effectiveHolidayDate,
        state: this.holiday.state
      })
      this.tiposDeFeriados = this.tiposDeFeriados.filter(x => x != this.holiday.holidayType)
    }
  }

  save(){
    this.loading = true;
    const addHoliday: Holiday = {
      holidayType: this.menuFormHoliday.value.TipoFeriado,
      description: this.menuFormHoliday.value.description,
      holidayDate: this.menuFormHoliday.value.DateFeriado,
      effectiveHolidayDate: this.menuFormHoliday.value.EffectiveDate,
      state: this.menuFormHoliday.value.state,
      configLeaveOuId: this.holiday.configLeaveOuId,
      id:this.holiday.id
    }
    if(addHoliday.id == undefined)
    {
      this.leaveService.uploadHoliday(addHoliday).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(()=>{
        this.loading = false;
        this.dialogRef.close(true);
        this.msjService.showInfo(this.transloco.translate('settings.addDialogHoliday.holidayAddedMsg'));
      }, (_error) => {
        this.msjService.showError(this.transloco.translate('settings.addDialogHoliday.holidayAddErrorMsg'));
      })
    }
    else{
    this.leaveService.updateHoliday(addHoliday).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(()=>{
      this.loading = false;
      this.dialogRef.close(true);
      this.msjService.showInfo(this.transloco.translate('settings.addDialogHoliday.holidayUpdatedMsg'));
    }, (_error) => {
      this.msjService.showError(this.transloco.translate('settings.addDialogHoliday.holidayUpdateErrorMsg'));
    })
}
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setEffectiveDate(event: any)
  {
      const fecha = new Date(event.value);
      this.menuFormHoliday.patchValue({
        EffectiveDate: new Date(fecha.getFullYear(),fecha.getMonth(),fecha.getDate())
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yearFilter = (d: any): boolean => {
    const year = getYearFromDateLike(d);
    return year?.toString() === this.holidayYear;
  };

  disabledbutton()
  {
    const { TipoFeriado, description, DateFeriado, EffectiveDate } = this.menuFormHoliday.value;
    if(TipoFeriado == '' || description == '' || DateFeriado == '' || EffectiveDate == ''){
      return true;
    }
    else
   {
    return false;
   }

  }
}
